<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border col-lg card-col col-12">
        <a
          href="https://www.holidayextras.com/trailfinders/hotels.html"
          target="_new"
          class="vtd-card vtd-animate-shake"
          rel="noopener noreferrer"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">AIRPORT PARKING &amp; HOTELS</h4>
            <div class="nav-text-center">
              <i class="icon-airport_hotel vtd-icon-7"/>
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </a>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <a
          href="https://www.loungepass.com/tp/tf"
          target="_new"
          class="vtd-card vtd-animate-shake"
          rel="noopener noreferrer"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">AIRPORT LOUNGES</h4>
            <div class="nav-text-center">
              <i class="icon-airport_lounges vtd-icon-7"/>
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </a>
      </b-col>
    </b-row>
    <HomeBackBtns />
  </HomeLayout>
</template>

<script>
import HomeLayout from "@/partials/home-layout";
export default {
  components: {
    HomeLayout,
  }
};
</script>
